export function dispatchDataLayer(objDatLayer: any): void {
	if (!(window as any).dataLayer) {
		(window as any).dataLayer = [];
	}

	if ((window as any).dataLayer) {
		(window as any).dataLayer.push(objDatLayer);
	}
}